var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 18.75L4.6875 12L11.4375 5.25M5.625 12L19.3125 12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow_white.e1ff55ffca30a8fecdf5dd783c0709c0.svg";
export { ForwardRef as ReactComponent };